var React = require('react');

function PaginationRightDouble (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m361.52-480-183-184 74.09-74.09L510.7-480 252.61-221.91 178.52-296l183-184Zm271.35 0L449.3-664l74.09-74.09L781.48-480 523.39-221.91 449.3-296l183.57-184Z"}));
}

PaginationRightDouble.defaultProps = {"height":"24","viewBox":"0 -960 960 960","width":"24"};

module.exports = PaginationRightDouble;

PaginationRightDouble.default = PaginationRightDouble;
